
window.headerTheme = {
  _value: null,
  get value() {
    return this._value
  },
  set(theme) {
    if (this._value === theme) return
    this._value = theme
    document.dispatchEvent(new CustomEvent('header:theme-change', { detail: { theme } }))
  },
  clear() {
    if (this._value === null) return
    this._value = null
    document.dispatchEvent(new CustomEvent('header:theme-change', { detail: { theme: null } }))
  },
}

const header = document.querySelector('header')

if (header && document.body.classList.contains('template-index')) {
  const setTheme = (theme) => {
    if (theme) {
      header.dataset.headerTheme = theme
      window.headerTheme.set(theme)
    } else {
      delete header.dataset.headerTheme
      window.headerTheme.clear()
    }
  }

  const applyTheme = () => {
    const headerBottom = header.getBoundingClientRect().bottom

    const atNav = tracked.findLast(({ el }) => {
      const rect = el.getBoundingClientRect()
      return rect.top <= headerBottom && rect.bottom > headerBottom
    })
    if (atNav) { setTheme(atNav.theme); return }

    const visible = tracked.findLast(({ el }) => {
      const rect = el.getBoundingClientRect()
      return rect.top < window.innerHeight && rect.bottom > 0
    })
    setTheme(visible?.theme ?? null)
  }

  const themedSections = [...document.querySelectorAll('[data-section-theme]')]
  const footerEl = document.querySelector('footer')

  const tracked = [
    ...themedSections.map((el) => ({ el, theme: el.dataset.sectionTheme })),
    ...(footerEl ? [{ el: footerEl, theme: 'dark' }] : []),
  ].sort((a, b) =>
    a.el.compareDocumentPosition(b.el) & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : 1,
  )

  applyTheme()
  window.addEventListener('scroll', applyTheme, { passive: true })
}
